import mora from '../assets/icons/mora.png'
import resin from '../assets/icons/resin.png'
import expBook from '../assets/icons/expBook.png'
import redo from '../assets/icons/redo.png'
import primogem from '../assets/icons/primogem.png'

export const icons = [
    {
        name : 'mora',
        path : mora
    },
    {
        name: 'resin',
        path : resin
    },
    {
        name: 'expBook',
        path : expBook
    },
    {
        name: 'redo',
        path : redo
    },
    {
        name: 'primogem',
        path : primogem
    }
]